import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import ScrollToTop from '@/components/shared/ScrollToTop/ScrollToTop.tsx';

const SimpleCenter: FC = () => {
  return (
    <>
      <ScrollToTop />
      <main
        id="app-main"
        className="flex flex-col grow min-h-[100dvh] justify-center items-center p-4 md:p-8 overflow-auto"
      >
        <Outlet />
      </main>
    </>
  );
};

export default SimpleCenter;
